export default "__VITE_ASSET__C9GvZ023__"